import React, {useState, createContext} from 'react'

export const AppContext = createContext();

export function AppProvider(props){
  const [activeFeature, setActiveFeature] = useState();
  return <AppContext.Provider value={{
    activeFeature,
    setActiveFeature
  }} {...props} />
}
